import React, { useState } from 'react';
import { normalizeImageUrl, isGoogleDriveUrl, extractGoogleDriveId } from '../utils/imageUtils';
import GoogleDriveImage from './GoogleDriveImage';

const SmartImage = ({ 
  src, 
  alt = 'Image', 
  width = 60, 
  height = 60, 
  className = '',
  imgStyle = {},
  fallbackIcon = 'fas fa-image',
  showFallback = true
}) => {
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // 🔧 Sanitize width/height → éviter NaN fontSize (si props est un string, null, undefined...)
  const _w = Number(width); const _h = Number(height);
  const safeWidth = Number.isFinite(_w) && _w > 0 ? _w : 60;
  const safeHeight = Number.isFinite(_h) && _h > 0 ? _h : 60;
  const fallbackFontSize = (() => {
    const f = Math.min(safeWidth, safeHeight) * 0.4;
    return Number.isFinite(f) && f > 0 ? f : 24;
  })();

  const normalizedSrc = normalizeImageUrl(src);
  const googleDriveId = extractGoogleDriveId(src);
  
  // Debug: afficher les URLs pour diagnostiquer
  
  // Si c'est une URL Google Drive, utiliser le composant spécialisé
  if (googleDriveId) {
    return (
      <GoogleDriveImage
        fileId={googleDriveId}
        alt={alt}
        width={safeWidth}
        height={safeHeight}
        className={className}
        imgStyle={imgStyle}
      />
    );
  }
  
  const handleError = (e) => {
    setHasError(true);
    setIsLoading(false);
  };

  const handleLoad = () => {
    setIsLoading(false);
  };

  if (!normalizedSrc || hasError) {
    return (
      <div 
        className={`smart-image-container ${className}`}
        style={{ 
          width: safeWidth, 
          height: safeHeight, 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          backgroundColor: '#f5f5f5',
          border: '1px solid #d9d9d9',
          borderRadius: '4px',
          ...imgStyle 
        }}
      >
        {showFallback && (
          <i 
            className={fallbackIcon} 
            style={{ 
              fontSize: fallbackFontSize,
              color: '#999',
              display: 'flex'
            }}
          />
        )}
      </div>
    );
  }

  return (
    <div 
      className={`smart-image-container ${className}`}
      style={{ 
        width: safeWidth, 
        height: safeHeight, 
        position: 'relative',
        overflow: 'hidden',
        borderRadius: '8px',
        backgroundColor: '#f7fafc'
      }}
    >
      {isLoading && (
        <div 
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#f7fafc',
            zIndex: 1
          }}
        >
          <i className="fas fa-spinner fa-spin" style={{ color: '#cbd5e0' }}></i>
        </div>
      )}
      <img
        src={normalizedSrc}
        alt={alt}
        onError={handleError}
        onLoad={handleLoad}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          display: isLoading ? 'none' : 'block',
          ...imgStyle
        }}
      />
    </div>
  );
};

export default SmartImage;
